import { Link } from 'react-router-dom';
import cn from 'bem-cn';

import { RoutePaths } from '../../constants';
import { NavigationElements } from '../../components/Navigation';
import { WebAppLayout } from '../../layouts/WebAppLayout';
import { HeaderElements } from '../../components/Header/Header.types';
import { Stack, Icon } from '../../components/UI';

import './NewPromptFailurePage.scss';

const b = cn('new-prompt-failure-page');

export const NewPromptFailurePage = () => {
    const getNavigationElements = () => {
        return [
            {
                text: 'На главную',
                to: RoutePaths.Main,
                accent: true,
            },
        ];
    };

    const navigationElements: NavigationElements = {
        desktop: getNavigationElements(),
        mobile: getNavigationElements(),
    };

    const headerElements: HeaderElements = {
        desktop: {
            left: {
                type: 'logo',
            },
            right: {
                type: 'profile',
            },
        },
        mobile: {
            right: {
                type: 'custom',
                render: () => {
                    return (
                        <Link to={RoutePaths.Main}>
                            <Icon name="close" size={24} />
                        </Link>
                    );
                },
            },
        },
    };

    return (
        <WebAppLayout navigationElements={navigationElements} headerElements={headerElements}>
            <Stack className={b()}>
                <div className={b('close')}>
                    <Icon name="close" size={32} fillColor="var(--accent-color)" className={b('close-icon')} />
                </div>
                <h1 className={b('title')}>Что-то пошло не так</h1>
                <p className={b('subtitle')}>Но мы уже работаем над этим</p>
            </Stack>
        </WebAppLayout>
    );
};
